export default __webpack_public_path__ + "static/media/SIMBA_Blocks.5c09c1fd.pdf";